{
  "Satışlar": "Sales",
  "satis": {
    "Satışlar": "Sales",
    "Satış Ekle": "Add Sale",
    "Satış Düzenle": "Edit Sale",
    "Tarih": "Date",
    "Müşteri": "Insured",
    "Sigortalı": "Insured",
    "Sigorta Ettiren": "Insured By",
    "Ürün": "Product",
    "Poliçe No": "Policy No",
    "Tutar (₺)": "Amount (₺)",
    "Tutar ($)": "Amount ($)",
    "Tutar": "Amount",
    "Kur": "Rate",
    "Açıklama": "Note",
    "Durum": "Status",
    "Ekle": "Add",
    "Filtrele": "Filter",
    "Data Yenile": "Refresh Data",
    "Onaysız": "Unapproved",
    "Onay": "Approved",
    "Cayma": "Withdrawal",
    "Not": "Note",
    "İptal": "Cancelled",
    "Bilinmiyor": "Unknown",
    "Kaydet": "Save",
    "Güncelle": "Update",
    "Filtreleri Temizle": "Clear Filters",
    "Temizle": "Clear",
    "Kapat": "Close",
    "İşlem": "Action",
    "Ara": "Search",
    "Düzenle": "Edit",
    "Sil": "Delete",
    "Detay": "Detail",
    "Veriler yüklenemedi": "Data could not be loaded",
    "Hata oluştu": "An error occurred",
    "Silme işlemi başarısız": "Deletion failed",
    "Satış Tipi": "Sale Type",
    "Ödeme Şekli": "Payment Method",
    "Network": "Network",
    "Sağlık": "Health",
    "Doğum": "Birth",
    "Aktarım Tutar": "Transfer Amount (₺)",
    "Silme Onayı": "Delete Confirmation",
    "Bu kaydı silmek istediğinize emin misiniz?": "Are you sure you want to delete this record?"
  }
}
